export default "//static.tradera.net/touchweb/static/output/images/google-play-badge-se.fd301529.png";